
import { Vue, Component } from 'vue-property-decorator'
import axios from 'axios'
import Role from '@/types/role'
import PermissionMatrix from '@/types/permissionMatrix'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {}
})

export default class RoleShow extends Vue {
  settings = {
    routeNames: { list: 'roles', show: 'roleShow', edit: 'roleEdit' },
    routeParamKey: 'roleId',
    functionNames: { setCurrent: 'setCurrentRole', clearCurrent: 'clearCurrentRole' },
    getterNames: { current: 'currentRole', loading: 'loadingRole' }
  }

  permissionMatrix:{ [key: string]: PermissionMatrix } = {}

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.setCurrent, this.$route.params[this.settings.routeParamKey])
    this.getPermissionMatrix()
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  getPermissionMatrix () : void {
    axios.get(process.env.VUE_APP_API_URL + '/roles/permissionMatrix').then((res) => {
      this.permissionMatrix = res.data
    })
  }

  navigateTo (routeName:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { [this.settings.routeParamKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get allPermissionsIdsInGroup () : { [key: string]: { [key: string]: number[] } } {
    const allPermissions:{ [key: string]: { [key: string]: number[] } } = {}
    const actions = ['view', 'edit', 'delete']

    Object.keys(this.permissionMatrix).forEach((group:string) => {
      allPermissions[group] = {}
      actions.forEach((action:string) => {
        if (!allPermissions[group][action]) {
          allPermissions[group][action] = []
        }

        if (this.permissionMatrix[group].permissions.base.actions[action]) {
          allPermissions[group][action].push(this.permissionMatrix[group].permissions.base.actions[action].id)
        }

        Object.keys(this.permissionMatrix[group].permissions.sections).forEach((section:string) => {
          if (this.permissionMatrix[group].permissions.sections[section].actions[action]) {
            allPermissions[group][action].push(this.permissionMatrix[group].permissions.sections[section].actions[action].id)
          }
        })
      })
    })

    return allPermissions
  }

  get allSelectedInGroup () : { [key: string]: { [key: string]: boolean } } {
    const allSelected:{ [key: string]: { [key: string]: boolean } } = {}
    const actions = ['view', 'edit', 'delete']

    Object.keys(this.allPermissionsIdsInGroup).forEach((group:string) => {
      allSelected[group] = {}
      actions.forEach((action:string) => {
        if (!allSelected[group][action]) {
          allSelected[group][action] = true
        }
        this.allPermissionsIdsInGroup[group][action].forEach((permissionId:number) => {
          if (!this.currentItem.permissions.includes(permissionId)) {
            allSelected[group][action] = false
          }
        })
      })
    })

    return allSelected
  }

  get currentItem () : Role {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }
}
